import uuid from '../utils/uuid.utils';

export class CloseWebviewEvent {
  static FinishFlowStatus = {
    SUCCESS: 'success',
    ERROR: 'error',
  };

  static WebviewContext = {
    FINISH_FLOW: 'finish_flow',
    CLOSED_BY_USER: 'closed_by_user',
    ERROR: 'error',
  };

  static finishSuccessfully(extraData = {}) {
    window.__CAAS__.triggerNative(window.__CAAS__.events.closeWebview, uuid(), {
      context: CloseWebviewEvent.WebviewContext.FINISH_FLOW,
      status: CloseWebviewEvent.FinishFlowStatus.SUCCESS,
      ...extraData,
    });
  }

  static closedByUser(extraData = {}) {
    window.__CAAS__.triggerNative(window.__CAAS__.events.closeWebview, uuid(), {
      context: CloseWebviewEvent.WebviewContext.CLOSED_BY_USER,
      ...extraData,
    });
  }

  static finishWithError(extraData = {}) {
    window.__CAAS__.triggerNative(window.__CAAS__.events.closeWebview, uuid(), {
      context: CloseWebviewEvent.WebviewContext.ERROR,
      status: CloseWebviewEvent.FinishFlowStatus.ERROR,
      ...extraData,
    });
  }
}
